/* eslint-disable no-plusplus */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import {
  onConvertNumber,
  onGetTIR,
  onFormatResultValue,
  onFormatNegate,
} from 'utils'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faAlignJustify } from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import styles from './calculadora.module.css'

const JurosCompostosHeterogenio = () => {
  const defaultInputValue = '0,00'
  const defaultInputValueMonths = '0,00'
  const defaultInputMonths = '1'
  const [linkToRedirect, setLinkToRedirect] = useState(null)
  const [decimalVPL, setDecimalVPL] = useState(3)
  const [decimalTIR, setDecimalTIR] = useState(3)
  const [updateDecimal, setUpdateDecimal] = useState(false)
  const [inputSelected, setInputSelected] = useState(0)
  const [inputs, onSetInputs] = useState([
    {
      value: defaultInputValue.toString(),
      selected: true,
      result: false,
    },
    {
      value: defaultInputValue.toString(),
      selected: false,
      result: true,
    },
    {
      value: defaultInputValue.toString(),
      selected: false,
      result: true,
    },
    {
      value: defaultInputValue.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValueMonths.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputMonths.toString(),
      selected: false,
      result: false,
    },
  ])

  const inputValue1 = parseFloat(onConvertNumber(inputs[0].value))
  const inputValue2 = parseFloat(onConvertNumber(inputs[1].value))
  const inputValue3 = parseFloat(onConvertNumber(inputs[2].value))
  const inputValue4 = parseFloat(onConvertNumber(inputs[3].value))
  const inputValue5 = parseFloat(onConvertNumber(inputs[4].value))

  const onKeyPress = event =>
    (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 0

  const onSetInput = id => {
    onSetInputs(current => ({
      ...current,
      [inputSelected]: {
        ...current[inputSelected],
        selected: false,
      },
    }))
    onSetInputs(current => ({
      ...current,
      [id]: {
        ...current[id],
        selected: true,
      },
    }))
    setInputSelected(id)
  }

  const onGetResult = () => {
    let resultVPL = 0
    let resultTIR = 0
    let block = false

    let IRRval = []
    let total = 0
    let x = 0.0
    let meses = 0
    const cfj = []
    let ctfValue = 0
    let monthsValue = 0

    let tax = parseFloat(inputValue1 / 100)
    tax = parseFloat(1 / (1 + tax))

    if (
      inputValue1.toString().slice(-1) === ',' ||
      inputValue2.toString().slice(-1) === ',' ||
      inputValue3.toString().slice(-1) === ',' ||
      inputValue4.toString().slice(-1) === ',' ||
      inputValue5.toString().slice(-1) === ','
    ) {
      block = true
    }

    if (!block) {
      for (let i = 4; i <= 75; i++) {
        if (i % 2 !== 0) {
          if (Number.isNaN(parseFloat(onConvertNumber(inputs[i].value)))) {
            meses += 0
          } else {
            meses += parseFloat(onConvertNumber(inputs[i].value))
            monthsValue++
          }
          for (
            let z = 1;
            z <= parseFloat(onConvertNumber(inputs[i].value));
            z++
          ) {
            if (
              Number.isNaN(parseFloat(onConvertNumber(inputs[i - 1].value)))
            ) {
              cfj.push(0)
            } else {
              cfj.push(inputs[i - 1].value)
            }
          }
        }

        if (i % 2 === 0) {
          if (Number.isNaN(parseFloat(onConvertNumber(inputs[i].value)))) {
            // continue
          } else {
            ctfValue++
          }
        }
      }

      if (
        Number.isNaN(parseFloat(onConvertNumber(inputValue1))) ||
        Number.isNaN(parseFloat(onConvertNumber(inputValue4))) ||
        monthsValue !== ctfValue
      ) {
        // continue
      } else {
        IRRval = Math.round(inputValue4)
        let somaCFJ = 0
        for (let i = 0; i < meses; i++) {
          IRRval += '; '
          IRRval +=
            cfj[i] === '0,00' ? parseFloat(onConvertNumber(cfj[i])) : cfj[i]
          somaCFJ +=
            cfj[i] === '0,00'
              ? parseFloat(onConvertNumber(cfj[i]))
              : parseFloat(cfj[i])
        }

        for (let i = 0; i < meses; i++) {
          x = parseFloat(tax ** (i + 1))
          total +=
            cfj[i] === '0,00'
              ? parseFloat(onConvertNumber(cfj[i]))
              : parseFloat(onConvertNumber(cfj[i]) * x)

          if (Number.isNaN(parseFloat(total))) {
            resultTIR = 0
            resultVPL = 0
            break
          }
        }

        resultVPL = parseFloat(inputValue4) + parseFloat(total)

        if (IRRval.length > 1) {
          const soma = parseFloat(inputValue4) + somaCFJ

          if (parseFloat(inputValue4) < 0) {
            if (soma < 0 && somaCFJ !== 0) {
              resultTIR = 'TIR < 0'
            } else {
              resultTIR = Math.abs(
                onGetTIR(
                  IRRval.split(';').map(valor =>
                    parseFloat(onConvertNumber(valor)),
                  ),
                ),
              )
            }
          } else if (parseFloat(inputValue4) > 0) {
            if (soma > 0 && somaCFJ !== 0) {
              resultTIR = 'TIR < 0'
            } else {
              resultTIR = Math.abs(
                onGetTIR(
                  IRRval.split(';').map(valor =>
                    parseFloat(onConvertNumber(valor)),
                  ),
                ),
              )
            }
          } else if (parseFloat(inputValue4) === 0) {
            let stop = false
            IRRval.split(';')
              .map(valor => parseFloat(onConvertNumber(valor)))
              .forEach(numero => {
                if (numero !== 0) {
                  if (!stop) {
                    if (numero < 0 && somaCFJ !== 0 && soma < 0) {
                      resultTIR = 'TIR < 0'
                      stop = true
                    } else if (numero > 0 && somaCFJ !== 0 && soma > 0) {
                      resultTIR = 'TIR < 0'
                      stop = true
                    } else {
                      resultTIR = Math.abs(
                        onGetTIR(
                          IRRval.split(';').map(valor =>
                            parseFloat(onConvertNumber(valor)),
                          ),
                        ),
                      )
                      stop = true
                    }
                  }
                }
              })
          }
        }
      }
    }

    if (Number.isNaN(parseFloat(resultVPL))) {
      onSetInputs(current => ({
        ...current,
        1: {
          ...current[1],
          value: '0,00',
        },
      }))
    } else {
      if (!block) {
        onSetInputs(current => ({
          ...current,
          1: {
            ...current[1],
            value: onFormatResultValue(resultVPL, decimalVPL),
          },
        }))
      }
    }

    if (resultTIR === 'TIR < 0') {
      onSetInputs(current => ({
        ...current,
        2: {
          ...current[2],
          value: 'TIR < 0',
        },
      }))
    } else if (
      Number.isNaN(parseFloat(resultTIR)) &&
      parseFloat(inputValue4) !== 0
    ) {
      onSetInputs(current => ({
        ...current,
        2: {
          ...current[2],
          value: '0,00',
        },
      }))
    } else {
      if (!block) {
        onSetInputs(current => ({
          ...current,
          2: {
            ...current[2],
            value:
              parseFloat(inputValue4) === 0
                ? 0
                : onFormatResultValue(resultTIR, decimalTIR),
          },
        }))
      }
    }
  }

  useEffect(() => {
    onGetResult()
  }, [decimalTIR, decimalVPL])

  const onAddDigit = num => {
    let inputValue = 0

    if (
      inputs[inputSelected].value === '0' ||
      inputs[inputSelected].value === '0,00'
    ) {
      inputValue = num
    } else {
      inputValue = '' + inputs[inputSelected].value + num
    }

    if (updateDecimal) {
      if (inputSelected === 1) {
        setDecimalVPL(num)
      } else if (inputSelected === 2) {
        setDecimalTIR(num)
      } else {
        setDecimalVPL(num)
        setDecimalTIR(num)
      }
      setUpdateDecimal(false)
    } else if (!inputs[inputSelected].result) {
      onSetInputs(current => ({
        ...current,
        [inputSelected]: {
          ...current[inputSelected],
          value: inputValue,
        },
      }))
    }
  }

  const onAddDigitDecimal = () => {
    let inputValue = inputs[inputSelected].value.toString()
    if (inputValue.indexOf(',') === -1) {
      inputValue += ','
      onSetInputs(current => ({
        ...current,
        [inputSelected]: {
          ...current[inputSelected],
          value: inputValue,
        },
      }))
    }
  }

  const onClearAllInputs = () => {
    for (let index = 0; index < 4; index++) {
      onSetInputs(current => ({
        ...current,
        [index]: {
          ...current[index],
          value: defaultInputValue.toString(),
        },
      }))
    }
    for (let index = 4; index < 76; index = index + 2) {
      onSetInputs(current => ({
        ...current,
        [index]: {
          ...current[index],
          value: defaultInputValue.toString(),
        },
      }))
    }

    for (let index = 5; index < 76; index = index + 2) {
      onSetInputs(current => ({
        ...current,
        [index]: {
          ...current[index],
          value: defaultInputMonths.toString(),
        },
      }))
    }
  }

  const onClearSelectedInput = () => {
    onSetInputs(current => ({
      ...current,
      [inputSelected]: {
        ...current[inputSelected],
        value: defaultInputValue.toString(),
      },
    }))
  }

  const onNegate = () => {
    onSetInputs(current => ({
      ...current,
      [inputSelected]: {
        ...current[inputSelected],
        value: onFormatNegate(inputs[inputSelected].value),
      },
    }))
  }

  const onSetDecimal = () => {
    setUpdateDecimal(true)
  }

  const handleChange = () => false

  if (linkToRedirect) {
    return <Redirect to={linkToRedirect} />
  }

  return (
    <>
      <div className={styles.container}>
        <header>
          <h1 id="titulo" className={styles.title}>
            Calculadora Financeira – AP
          </h1>
          <h2 id="tema" className={styles.subtitle}>
            Juros Compostos – Fluxos Heterogêneos
          </h2>
        </header>
        <div id="calculadora" className={styles.calculadora}>
          <section id="entradas">
            <div className="form entradas">
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>i</span>
                <input
                  readOnly
                  style={
                    inputs[0].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  tabIndex={-1}
                  onChange={() => handleChange()}
                  value={inputs[0].value}
                  className={styles.inputSize}
                  id="i"
                  type="text"
                  name="i"
                  disable={inputs[0].result.toString()}
                  onKeyPress={e => onKeyPress(e)}
                  onFocus={() => onSetInput(0)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>VPL</span>
                <input
                  readOnly
                  style={
                    inputs[1].result
                      ? { backgroundColor: 'rgba(84, 212, 84, 0.57)' }
                      : inputs[1].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  tabIndex={-2}
                  onChange={() => handleChange()}
                  value={inputs[1].value}
                  className={styles.inputSize}
                  id="vpl"
                  type="text"
                  name="vpl"
                  disable={inputs[1].result.toString()}
                  onKeyPress={e => onKeyPress(e)}
                  onFocus={() => onSetInput(1)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>TIR</span>
                <input
                  readOnly
                  style={
                    inputs[2].result
                      ? { backgroundColor: 'rgba(84, 212, 84, 0.57)' }
                      : inputs[2].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  tabIndex={-3}
                  onChange={() => handleChange()}
                  value={inputs[2].value}
                  className={styles.inputSize}
                  id="tir"
                  type="text"
                  name="tir"
                  disable={inputs[2].result.toString()}
                  onKeyPress={e => onKeyPress(e)}
                  onFocus={() => onSetInput(2)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>CF0</span>
                <input
                  readOnly
                  style={
                    inputs[3].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  tabIndex={-4}
                  onChange={() => handleChange()}
                  value={inputs[3].value}
                  className={styles.inputSize}
                  id="cf0"
                  type="text"
                  name="cf0"
                  disable={inputs[3].result.toString()}
                  onKeyPress={e => onKeyPress(e)}
                  onFocus={() => onSetInput(3)}
                />
              </div>
            </div>
          </section>
          <section id="valoresHeader" className={styles.valoresHeader}>
            <div className={styles.inputGroup}>
              <span className={styles.spanText}>CFj</span>
              <span id="valor" className={styles.spanTextMedium}>
                Valor <i className="fa fa-angle-up" aria-hidden="true" />
              </span>
              <span className={styles.spanText}>Nj</span>
            </div>
            <div id="valores" className={styles.valores}>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>01</span>
                <input
                  readOnly
                  style={
                    inputs[4].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-5}
                  id="5"
                  type="text"
                  name=""
                  value={inputs[4].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(4)}
                />
                <input
                  readOnly
                  style={
                    inputs[5].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-6}
                  id="6"
                  type="text"
                  name="6"
                  value={inputs[5].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(5)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>02</span>
                <input
                  readOnly
                  style={
                    inputs[6].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-7}
                  id="7"
                  type="text"
                  name="7"
                  value={inputs[6].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(6)}
                />
                <input
                  readOnly
                  style={
                    inputs[7].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-8}
                  id="8"
                  type="text"
                  name="8"
                  value={inputs[7].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(7)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>03</span>
                <input
                  readOnly
                  style={
                    inputs[8].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-9}
                  id="9"
                  type="text"
                  name="9"
                  value={inputs[8].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(8)}
                />
                <input
                  readOnly
                  style={
                    inputs[9].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-10}
                  id="10"
                  type="text"
                  name="10"
                  value={inputs[9].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(9)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>04</span>
                <input
                  readOnly
                  style={
                    inputs[10].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-11}
                  id="11"
                  type="text"
                  name="11"
                  value={inputs[10].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(10)}
                />
                <input
                  readOnly
                  style={
                    inputs[11].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-12}
                  id="12"
                  type="text"
                  name="12"
                  value={inputs[11].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(11)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>05</span>
                <input
                  readOnly
                  style={
                    inputs[12].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-13}
                  id="13"
                  type="text"
                  name="13"
                  value={inputs[12].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(12)}
                />
                <input
                  readOnly
                  style={
                    inputs[13].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-14}
                  id="14"
                  type="text"
                  name="14"
                  value={inputs[13].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(13)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>06</span>
                <input
                  readOnly
                  style={
                    inputs[14].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-15}
                  id="15"
                  type="text"
                  name="15"
                  value={inputs[14].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(14)}
                />
                <input
                  readOnly
                  style={
                    inputs[15].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-16}
                  id="16"
                  type="text"
                  name="16"
                  value={inputs[15].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(15)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>07</span>
                <input
                  readOnly
                  style={
                    inputs[16].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-17}
                  id="17"
                  type="text"
                  name="17"
                  value={inputs[16].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(16)}
                />
                <input
                  readOnly
                  style={
                    inputs[17].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-18}
                  id="18"
                  type="text"
                  name="18"
                  value={inputs[17].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(17)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>08</span>
                <input
                  readOnly
                  style={
                    inputs[18].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-19}
                  id="19"
                  type="text"
                  name="19"
                  value={inputs[18].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(18)}
                />
                <input
                  readOnly
                  style={
                    inputs[19].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-20}
                  id="20"
                  type="text"
                  name="20"
                  value={inputs[19].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(19)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>09</span>
                <input
                  readOnly
                  style={
                    inputs[20].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-21}
                  id="21"
                  type="text"
                  name="21"
                  value={inputs[20].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(20)}
                />
                <input
                  readOnly
                  style={
                    inputs[21].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-22}
                  id="22"
                  type="text"
                  name="22"
                  value={inputs[21].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(21)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>10</span>
                <input
                  readOnly
                  style={
                    inputs[22].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-23}
                  id="23"
                  type="text"
                  name="23"
                  value={inputs[22].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(22)}
                />
                <input
                  readOnly
                  style={
                    inputs[23].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-24}
                  id="24"
                  type="text"
                  name="24"
                  value={inputs[23].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(23)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>11</span>
                <input
                  readOnly
                  style={
                    inputs[24].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-25}
                  id="25"
                  type="text"
                  name="25"
                  value={inputs[24].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(24)}
                />
                <input
                  readOnly
                  style={
                    inputs[25].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-26}
                  id="26"
                  type="text"
                  name="26"
                  value={inputs[25].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(25)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>12</span>
                <input
                  readOnly
                  style={
                    inputs[26].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-27}
                  id="27"
                  type="text"
                  name="27"
                  value={inputs[26].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(26)}
                />
                <input
                  readOnly
                  style={
                    inputs[27].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-28}
                  id="28"
                  type="text"
                  name="28"
                  value={inputs[27].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(27)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>13</span>
                <input
                  readOnly
                  style={
                    inputs[28].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-29}
                  id="29"
                  type="text"
                  name="29"
                  value={inputs[28].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(28)}
                />
                <input
                  readOnly
                  style={
                    inputs[29].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-30}
                  id="30"
                  type="text"
                  name="30"
                  value={inputs[29].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(29)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>14</span>
                <input
                  readOnly
                  style={
                    inputs[30].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-31}
                  id="31"
                  type="text"
                  name="31"
                  value={inputs[30].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(30)}
                />
                <input
                  readOnly
                  style={
                    inputs[31].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-32}
                  id="32"
                  type="text"
                  name="32"
                  value={inputs[31].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(31)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>15</span>
                <input
                  readOnly
                  style={
                    inputs[32].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-33}
                  id="33"
                  type="text"
                  name="33"
                  value={inputs[32].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(32)}
                />
                <input
                  readOnly
                  style={
                    inputs[33].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-34}
                  id="34"
                  type="text"
                  name="34"
                  value={inputs[33].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(33)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>16</span>
                <input
                  readOnly
                  style={
                    inputs[34].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-35}
                  id="35"
                  type="text"
                  name="35"
                  value={inputs[34].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(34)}
                />
                <input
                  readOnly
                  style={
                    inputs[35].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-36}
                  id="36"
                  type="text"
                  name="36"
                  value={inputs[35].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(35)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>17</span>
                <input
                  readOnly
                  style={
                    inputs[36].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-37}
                  id="37"
                  type="text"
                  name="37"
                  value={inputs[36].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(36)}
                />
                <input
                  readOnly
                  style={
                    inputs[37].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-38}
                  id="38"
                  type="text"
                  name="38"
                  value={inputs[27].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(37)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>18</span>
                <input
                  readOnly
                  style={
                    inputs[38].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-39}
                  id="39"
                  type="text"
                  name="39"
                  value={inputs[38].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(38)}
                />
                <input
                  readOnly
                  style={
                    inputs[39].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-40}
                  id="40"
                  type="text"
                  name="40"
                  value={inputs[39].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(39)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>19</span>
                <input
                  readOnly
                  style={
                    inputs[40].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-41}
                  id="41"
                  type="text"
                  name="41"
                  value={inputs[40].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(40)}
                />
                <input
                  readOnly
                  style={
                    inputs[41].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-42}
                  id="42"
                  type="text"
                  name="42"
                  value={inputs[41].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(41)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>20</span>
                <input
                  readOnly
                  style={
                    inputs[42].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-43}
                  id="43"
                  type="text"
                  name="43"
                  value={inputs[42].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(42)}
                />
                <input
                  readOnly
                  style={
                    inputs[43].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-44}
                  id="44"
                  type="text"
                  name="44"
                  value={inputs[43].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(43)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>21</span>
                <input
                  readOnly
                  style={
                    inputs[44].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-45}
                  id="45"
                  type="text"
                  name="45"
                  value={inputs[44].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(44)}
                />
                <input
                  readOnly
                  style={
                    inputs[45].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-46}
                  id="46"
                  type="text"
                  name="46"
                  value={inputs[45].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(45)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>22</span>
                <input
                  readOnly
                  style={
                    inputs[46].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-47}
                  id="47"
                  type="text"
                  name="47"
                  value={inputs[46].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(46)}
                />
                <input
                  readOnly
                  style={
                    inputs[47].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-48}
                  id="48"
                  type="text"
                  name="48"
                  value={inputs[47].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(47)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>23</span>
                <input
                  readOnly
                  style={
                    inputs[48].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-49}
                  id="49"
                  type="text"
                  name="49"
                  value={inputs[48].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(48)}
                />
                <input
                  readOnly
                  style={
                    inputs[49].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-50}
                  id="50"
                  type="text"
                  name="50"
                  value={inputs[49].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(49)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>24</span>
                <input
                  readOnly
                  style={
                    inputs[50].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-51}
                  id="51"
                  type="text"
                  name="51"
                  value={inputs[50].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(50)}
                />
                <input
                  readOnly
                  style={
                    inputs[51].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-52}
                  id="52"
                  type="text"
                  name="52"
                  value={inputs[51].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(51)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>25</span>
                <input
                  readOnly
                  style={
                    inputs[52].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-53}
                  id="53"
                  type="text"
                  name="53"
                  value={inputs[52].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(52)}
                />
                <input
                  readOnly
                  style={
                    inputs[53].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-54}
                  id="54"
                  type="text"
                  name="54"
                  value={inputs[53].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(53)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>26</span>
                <input
                  readOnly
                  style={
                    inputs[54].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-55}
                  id="55"
                  type="text"
                  name="55"
                  value={inputs[54].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(54)}
                />
                <input
                  readOnly
                  style={
                    inputs[55].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-56}
                  id="56"
                  type="text"
                  name="56"
                  value={inputs[55].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(55)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>27</span>
                <input
                  readOnly
                  style={
                    inputs[56].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-57}
                  id="57"
                  type="text"
                  name="57"
                  value={inputs[56].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(56)}
                />
                <input
                  readOnly
                  style={
                    inputs[57].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-58}
                  id="58"
                  type="text"
                  name="58"
                  value={inputs[57].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(57)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>28</span>
                <input
                  readOnly
                  style={
                    inputs[58].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-59}
                  id="59"
                  type="text"
                  name="59"
                  value={inputs[58].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(58)}
                />
                <input
                  readOnly
                  style={
                    inputs[59].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-60}
                  id="60"
                  type="text"
                  name="60"
                  value={inputs[59].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(59)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>29</span>
                <input
                  readOnly
                  style={
                    inputs[60].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-61}
                  id="61"
                  type="text"
                  name="61"
                  value={inputs[60].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(60)}
                />
                <input
                  readOnly
                  style={
                    inputs[61].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-62}
                  id="62"
                  type="text"
                  name="62"
                  value={inputs[61].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(61)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>30</span>
                <input
                  readOnly
                  style={
                    inputs[62].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-63}
                  id="63"
                  type="text"
                  name="63"
                  value={inputs[62].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(62)}
                />
                <input
                  readOnly
                  style={
                    inputs[63].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-64}
                  id="64"
                  type="text"
                  name="64"
                  value={inputs[63].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(63)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>31</span>
                <input
                  readOnly
                  style={
                    inputs[64].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-65}
                  id="65"
                  type="text"
                  name="65"
                  value={inputs[64].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(64)}
                />
                <input
                  readOnly
                  style={
                    inputs[65].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-66}
                  id="66"
                  type="text"
                  name="66"
                  value={inputs[65].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(65)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>32</span>
                <input
                  readOnly
                  style={
                    inputs[66].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-67}
                  id="67"
                  type="text"
                  name="67"
                  value={inputs[66].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(66)}
                />
                <input
                  readOnly
                  style={
                    inputs[67].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-68}
                  id="68"
                  type="text"
                  name="68"
                  value={inputs[67].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(67)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>33</span>
                <input
                  readOnly
                  style={
                    inputs[68].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-69}
                  id="69"
                  type="text"
                  name="69"
                  value={inputs[68].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(68)}
                />
                <input
                  readOnly
                  style={
                    inputs[69].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-70}
                  id="70"
                  type="text"
                  name="70"
                  value={inputs[69].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(69)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>34</span>
                <input
                  readOnly
                  style={
                    inputs[70].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-71}
                  id="71"
                  type="text"
                  name="71"
                  value={inputs[70].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(70)}
                />
                <input
                  readOnly
                  style={
                    inputs[71].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-72}
                  id="72"
                  type="text"
                  name="72"
                  value={inputs[71].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(71)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>35</span>
                <input
                  readOnly
                  style={
                    inputs[72].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-73}
                  id="73"
                  type="text"
                  name="73"
                  value={inputs[72].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(72)}
                />
                <input
                  readOnly
                  style={
                    inputs[73].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-74}
                  id="74"
                  type="text"
                  name="74"
                  value={inputs[73].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(73)}
                />
              </div>

              <div className={styles.inputGroup}>
                <span className={styles.spanText}>36</span>
                <input
                  readOnly
                  style={
                    inputs[74].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeMedium}
                  tabIndex={-75}
                  id="75"
                  type="text"
                  name="75"
                  value={inputs[74].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(74)}
                />
                <input
                  readOnly
                  style={
                    inputs[75].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  className={styles.inputSizeRight}
                  tabIndex={-76}
                  id="76"
                  type="text"
                  name="76"
                  value={inputs[75].value}
                  onKeyPress={e => onKeyPress(e)}
                  onClick={() => onSetInput(75)}
                />
              </div>
            </div>
          </section>
          <section id="keyboard">
            <div className={styles.row}>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(1)}
              >
                1
              </button>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(2)}
              >
                2
              </button>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(3)}
              >
                3
              </button>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(4)}
              >
                4
              </button>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(5)}
              >
                5
              </button>
              <button
                className={styles.keyButtonDarkRight}
                id="limpar"
                tabIndex="-1"
                onClick={() => onClearAllInputs()}
              >
                <font size="2">Clear</font>
              </button>
            </div>
            <div className={styles.row}>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(6)}
              >
                6
              </button>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(7)}
              >
                7
              </button>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(8)}
              >
                8
              </button>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(9)}
              >
                9
              </button>
              <button
                className={styles.keyButtonLight}
                tabIndex="-1"
                onClick={() => onAddDigit(0)}
              >
                0
              </button>
              <button
                className={styles.keyButtonDarkRight}
                tabIndex="-1"
                onClick={() => onClearSelectedInput()}
              >
                clx
              </button>
            </div>
            <div className={styles.row}>
              <button
                className={styles.keyButtonGreen}
                id="pontuacao"
                tabIndex="-1"
                onClick={() => onGetResult()}
              >
                Calc
              </button>
              <button
                className={styles.keyButtonDark}
                id="pontuacao"
                tabIndex="-1"
                onClick={() => onAddDigitDecimal()}
              >
                ,
              </button>
              <button
                className={styles.keyButtonDark}
                tabIndex="-1"
                onClick={() => onNegate()}
              >
                + / -
              </button>
              <button
                className={styles.keyButtonDark}
                tabIndex="-1"
                onClick={() => onSetDecimal()}
              >
                Dec.
              </button>
              <button className={styles.keyButtonDark} tabIndex="-1">
                <FontAwesomeIcon icon={faArrowDown} />
              </button>
              <button
                className={styles.keyButtonDarkRight}
                tabIndex="-1"
                onClick={() =>
                  confirmAlert({
                    customUI: ({ onClose }) => {
                      return (
                        <div className={styles.alert}>
                          <h1>Atenção</h1>
                          <p>Deseja realmente voltar ao menu?</p>
                          <button
                            className={styles.alertButton}
                            onClick={() => {
                              setLinkToRedirect('/')
                              onClose()
                            }}
                          >
                            Sim
                          </button>
                          <button
                            className={styles.alertButton}
                            onClick={onClose}
                          >
                            Não
                          </button>
                        </div>
                      )
                    },
                  })
                }
              >
                <FontAwesomeIcon icon={faAlignJustify} />
              </button>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default JurosCompostosHeterogenio
